import SideNav from '../../SideNav/SideNav';

import { useFirebaseAuth } from '../../../../global/FirebaseProvider/FirebaseProvider';

import styles from './HeaderAccount.module.scss';

const {
  main,
  container,
} = styles;

const HeaderAccount = () => {
  const { isSignedIn, loading } = useFirebaseAuth();

  if (!isSignedIn && !loading) {
    return null;
  }

  return (
    <div className={main}>
      <div className={container}>
        <SideNav />
      </div>
    </div>
  );
};

export default HeaderAccount;
